import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane, Table } from "reactstrap";
import { getDarkTableRow } from "../../../../Utils/otherFunctions";
import { ThemeContext } from "styled-components";

const TabModalDetailSS = ({ selectedCapaian }) => {
  const [activeTab, setActiveTab] = useState("1");
  console.log(selectedCapaian);

  const renderTableContent = (selectedCapaian, quarter) => {
    return (
      <TabPane tabId={quarter}>
        <Table responsive>
          <thead>
            <tr>
              <th className={getDarkTableRow(ThemeContext)}>Capaian</th>
              <th className={getDarkTableRow(ThemeContext)}>
                Capaian Normalisasi
              </th>
              <th className={getDarkTableRow(ThemeContext)}>
                Nilai Sasaran Strategis
              </th>
              <th className={getDarkTableRow(ThemeContext)}>
                Nilai Sasaran Strategis Normalisasi
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={getDarkTableRow(ThemeContext)}>
                {selectedCapaian[`capaian_tw_${quarter}`]}
              </td>
              <td className={getDarkTableRow(ThemeContext)}>
                {selectedCapaian[`capaian_normalisasi_tw_${quarter}`]}
              </td>
              <td className={getDarkTableRow(ThemeContext)}>
                {selectedCapaian[`nilai_sasaran_strategis_tw_${quarter}`]}
              </td>
              <td className={getDarkTableRow(ThemeContext)}>
                {
                  selectedCapaian[
                    `nilai_sasaran_strategis_normalisasi_tw_${quarter}`
                  ]
                }
              </td>
            </tr>
          </tbody>
        </Table>
        {/* <table className="align-middle">
          <tbody>
            <tr>
              <th scope="row" className={getDarkTableRow(ThemeContext)}>
                <strong>Capaian</strong>
              </th>
              <td className={"w-25 " + getDarkTableRow(ThemeContext)}>{selectedCapaian[`capaian_tw_${quarter}`]}</td>
              <th scope="row" className={getDarkTableRow(ThemeContext)}>
                <strong>Capaian Normalisasi</strong>
              </th>
              <td className={"w-25 " + getDarkTableRow(ThemeContext)}>{selectedCapaian[`capaian_normalisasi_tw_${quarter}`]}</td>
            </tr>
            <tr>
              <th scope="row" className={getDarkTableRow(ThemeContext)}>
                <strong>Nilai Sasaran Strategis</strong>
              </th>
              <td className={"w-25 " + getDarkTableRow(ThemeContext)}>{selectedCapaian[`nilai_sasaran_strategis_tw_${quarter}`]}</td>
              <th scope="row" className={getDarkTableRow(ThemeContext)}>
                <strong>Nilai Sasaran Strategis Normalisasi</strong>
              </th>
              <td className={"w-25 " + getDarkTableRow(ThemeContext)}>{selectedCapaian[`nilai_sasaran_strategis_normalisasi_tw_${quarter}`]}</td>
            </tr>
          </tbody>
        </table> */}
      </TabPane>
    );
  };

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <Nav className="my-5" tabs justified>
        <NavItem>
          <NavLink
            className={activeTab === "1" ? "active" : ""}
            onClick={() => handleChangeTab("1")}
          >
            Triwulan 1
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "2" ? "active" : ""}
            onClick={() => handleChangeTab("2")}
          >
            Triwulan 2
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "3" ? "active" : ""}
            onClick={() => handleChangeTab("3")}
          >
            Triwulan 3
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "4" ? "active" : ""}
            onClick={() => handleChangeTab("4")}
          >
            Triwulan 4
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        {renderTableContent(selectedCapaian, "1")}
        {renderTableContent(selectedCapaian, "2")}
        {renderTableContent(selectedCapaian, "3")}
        {renderTableContent(selectedCapaian, "4")}
      </TabContent>
    </div>
  );
};

export default TabModalDetailSS;
